import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

import { LoadingContextProvider } from "./Store/loading-context";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <LoadingContextProvider>
      <App />
    </LoadingContextProvider>
  </React.StrictMode>
);
